export default function sortableHelper() {
  return { adjustTop: adjustTop };

  function adjustTop(element) {
    $(element).sortable({
      sort: function(event, ui) {
        var $target = $(event.target);
        if (!/html|body/i.test($target.offsetParent()[0].tagName)) {
          var top = event.pageY - $target.offsetParent().offset().top - ui.helper.outerHeight(true) / 2;
          ui.helper.css({
            top: top + 'px',
          });
        }
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/sortable.helper.js